export default __webpack_public_path__ + "static/media/more-photos-icon.ff338708.svg";